import { Button} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";
import { useSnackbar } from "notistack";
import { useQueryClient } from "react-query";

export default function Weekly() {
  const { id,variant_id } = useParams();
  const navigate = useNavigate();
  const [date, setDate] = useState();
  const [value1, setValue1] = useState("");
  const currentYear = new Date();
  const futureYear = new Date(currentYear);
  futureYear.setMonth(currentYear.getMonth()+12);
 const formattedfutureYear = futureYear.toISOString().split('T')[0];
 const formattedcurrentYear = currentYear.toISOString().split('T')[0];

  

  const GetSubscriptionDaly = () => {
   
    const reqbody = {
      subscription_plan_id: id,
      product_variants_id: variant_id,
      yearly_subscription_details: {
        start_date: formattedcurrentYear,
      },
    };
    axiosInstance
    .post(API_URLS.yearlySubscription, reqbody)
    .then((response) => {
      alert(response?.data?.message);
      response.data.response_code===200 && addToCart( variant_id)
      localStorage.getItem("token");
      navigate("/subscription");
    })
    .catch((error) => {
      console.log(error);
    });
};
const handleLogin = (event) => {
  event.stopPropagation();
};
const { enqueueSnackbar } = useSnackbar();

const client = useQueryClient();
const addToCart = ( variantId) => {
  const reqBody = new FormData();
  reqBody.append("product_id", variantId);
  reqBody.append("add_quantity", 1);
  axiosInstance
    .post(API_URLS.addToCart, reqBody)
    .then((response) => {
      client.refetchQueries(["myCartList"]);
      enqueueSnackbar(response.data.status);
    })
    .catch((error) => {
      enqueueSnackbar("Something went wrong..!", { variant: "error" });
    });
};


  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  console.log("day", convert(value1));

  return (
    <>
    
    <div className=" hm1 h-[500px] py-5 text-center text-white">
    <p className="text-4xl py-10">Yearly Plan In 1 Year So Get Your Plan </p>
    <div className="flex gap-5 justify-center">
    <div className="flex flex-col gap-10">
    <p className="text-2xl">StartDate:</p>
    <p className="text-2xl">EndDate:</p>
 
    </div>
    <div className="flex flex-col gap-10">
    <p className="text-2xl">{formattedcurrentYear}</p>
   
     <p className="text-2xl">{formattedfutureYear}</p>
    
   <p className="text-2xl">{date?.pricing}</p>
    </div>
    </div>
    
    <div className="flex justify-center">
            <Button
          className="!p-3 hm2 !my-5 "
          onClick={GetSubscriptionDaly}
          variant="contained"
        >
          Confirm
        </Button>
      </div>
    </div>
    </>
  );
}
